import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import Loading from '../../Shared/Components/Loading';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
/** @format */
import Master from '../Layouts/Master';

const validationSchema = Yup.object().shape({
  provinces_id: Yup.array().typeError('').nullable(),
});

const UserRole = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const eventContext = useContext(EventContext);
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getRoles = async () => {
      setLoading(true);
      await useApi.get(
        `/province`,
        {},
        (res) => {
          eventContext.provinces = res.data.data;
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
      await useApi.get(
        `/event/${id}/access/province`,
        {},
        (res) => {
          eventContext.accessProvinceList = res.data.data;
          setLoading(false);
        },
        (err) => {
          setLoading(false);
          error('هنگام دریافت اطلاعات خطایی رخ داده است');
        },
      );
    };
    getRoles();
  }, [id]);

  const onSubmitForm = async (values, setSubmitting) => {
    setSubmitFormLoading(true);
    values['provinces_id'] = values.provinces_id?.map((p) => p.id);
    values['event_id'] = id;
    await useApi.post(
      '/event/access/province',
      values,
      (res) => {
        success('دسترسی با موفقیت داده شد');
        navigate('/panel/event');
      },
      (err) => {
        setSubmitFormLoading(false);
        error('خطایی در ثبت اطلاعات پیش آمده است.');
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <Formik
        initialValues={{
          provinces_id: eventContext.accessProvinceList?.provinces ?? [],
        }}
        onSubmit={(values, { setSubmitting }) => {
          onSubmitForm(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='d-flex flex-column border rounded p-2 mt-3'>
              <div className='w-100 form-group d-flex flex-row'>
                <div className='w-100 d-flex flex-column mt-1 mx-2'>
                  <label className='text-dark-mode f-14 text-right'>
                    انتخاب استان ها
                  </label>
                  <Select
                    isMulti
                    defaultValue={eventContext.accessProvinceList?.provinces}
                    closeMenuOnSelect={false}
                    options={eventContext.provinces}
                    onChange={(value) =>
                      setFieldValue('provinces_id', value, true)
                    }
                    noOptionsMessage={() => 'لطفا  استان ها را انتخاب کنید'}
                    getOptionLabel={(c) => c.name}
                    getOptionValue={(c) => c.id}
                    className='w-100'
                    placeholder='انتخاب کنید...'
                  />
                  <ErrorMessage classes='my-2' error={errors.provinces_id} />
                </div>
              </div>
            </div>
            <div className='d-flex flex-row justify-content-end'>
              <button className='btn btn-info btn-sm f-14'>
                {submitFormLoading ? (
                  <div
                    className='spinner-border spinner-border-sm text-white mb-1'
                    role='status'
                  ></div>
                ) : (
                  'ثبت دسترسی'
                )}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </Master>
  );
};

export default UserRole;
